module.exports = __webpack_public_path__ + "75dd6312eb2bf571828172d72174327d.pdf";